import { render, staticRenderFns } from "./ScreenMenu.vue?vue&type=template&id=f8c08a16"
import script from "./ScreenMenu.vue?vue&type=script&lang=js"
export * from "./ScreenMenu.vue?vue&type=script&lang=js"
import style0 from "./ScreenMenu.vue?vue&type=style&index=0&id=f8c08a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports